import { render, staticRenderFns } from "./CrearPoliza.vue?vue&type=template&id=e74b1a62"
import script from "./CrearPoliza.vue?vue&type=script&lang=js"
export * from "./CrearPoliza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports